import React from 'react';
import { IssueCandidate } from 'api/api.types';
import CandidateBar from 'lib/CandidateBar/CandidateBar';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

interface Props {
  list: IssueCandidate[];
  isElected: boolean;
  isFinal: boolean;
  hasNoWinner: boolean;
  absoluteMajority: number;
  maxVotes: number;
  issueId: string;
}

const CandidateBarGroup = ({
  list,
  isFinal,
  hasNoWinner,
  absoluteMajority,
  maxVotes,
  isElected,
  issueId,
}: Props) => {
  const { t } = useTranslation('wap');

  // if isFinal, we have a heading that produces the top space for the majority info
  // if !absoluteMajority, we don't need the space as we don't show the majority info
  const isMajorityInfoSpaceNeeded = !isFinal && absoluteMajority;

  return (
    <div
      className={classNames('electiondetails__candidate-list', {
        'electiondetails__candidate-list--prelim': isMajorityInfoSpaceNeeded,
      })}
    >
      {isFinal && <h3 className="h3">{isElected ? t('elected') : t('not_elected')}</h3>}
      <ol className="electiondetails__list">
        {list.map((candidate) => (
          <li className="electiondetails__list-item" key={issueId + candidate.id}>
            <CandidateBar
              candidate={candidate}
              maxVotes={hasNoWinner ? absoluteMajority : maxVotes}
              isFinal={isFinal}
            />
          </li>
        ))}
      </ol>
    </div>
  );
};

export default CandidateBarGroup;
